import queryBuilderReportMutations from "./mutations.js";
import queryBuilderReportActions from "./actions.js";
import queryBuilderReportGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      types : [],
      queryParameters:{},
      columnsRequired:[]
    };
  },
  mutations: queryBuilderReportMutations,
  actions: queryBuilderReportActions,
  getters: queryBuilderReportGetters,
};
